/** Kiểu thẻ hội thoại Ask HANA, dùng chung cho màn toàn trang, AskDock và `useAsk()`. */

export type Tone = 'err' | 'warn' | 'ok';
export type CiteKey = 'job' | 'sop' | 'money' | 'sched' | 'box' | 'booking' | 'bl' | 'tasks' | 'tms' | 'customers' | 'jobDetail';

export interface Cite { key: CiteKey; k: string; to: string }
export interface JobRow { id: string; route: string; sub: string; left: string; pct: number; tone: Tone; st: string }
export interface DocField { k: string; v: string; ok: boolean; why?: string }
export type ActId = 'remind' | 'note' | 'open';
export interface AskAct { id: ActId; k: string; primary: boolean }

export type Msg =
  | { me: true; text: string; files?: string[] }
  | { me?: false; ai: true; kind: 'jobs'; text: string; rows: JobRow[]; acts: AskAct[]; cites: Cite[] }
  | { me?: false; ai: true; kind: 'doc'; text: string; doc: [string, string]; fields: DocField[]; acts: AskAct[]; cites: Cite[] }
  | { me?: false; ai: true; kind: 'lock' | 'plain'; text: string; cites: Cite[] };

/** Đường dẫn trong Hub của các màn được trích dẫn (cùng tên miền, vùng Ezy / Box). */
export const CITE_DATA: Record<CiteKey, Omit<Cite, 'key'>> = {
  job: { k: 'Danh sách Job', to: '/ezy/jobs' },
  sop: { k: 'SOP 05 · Nhắc SI', to: '/ezy/sop' },
  money: { k: 'Quyền nhóm tiền', to: '/ezy/settings' },
  sched: { k: 'Lịch tàu', to: '/ezy/schedule' },
  box: { k: 'My Inbox', to: '/box' },
  booking: { k: 'Booking', to: '/ezy/booking' },
  bl: { k: 'Chứng từ & B/L', to: '/ezy/bl' },
  tasks: { k: 'Việc & Duyệt', to: '/ezy/tasks' },
  tms: { k: 'Điều độ', to: '/ezy/tms' },
  customers: { k: 'Khách hàng', to: '/ezy/customers' },
  jobDetail: { k: 'Job SE260609200', to: '/ezy/jobs' },
};
export const cite = (...keys: CiteKey[]): Cite[] => keys.map((key) => ({ key, ...CITE_DATA[key] }));
